/**
 * {@file} This is just to make everything look a little bit cleaner
 */

export type EmptyEventHandlerMap = Record<string, any>

export interface EventEmitter<T extends EmptyEventHandlerMap> {
    addEventListener<E extends keyof T>(type : E, listener: (this: any, ev: T[E]) => any, options?: boolean | AddEventListenerOptions | undefined): void
    removeEventListener<E extends keyof T>(type: E, listener: (this: any, ev: T[E]) => any, options?: boolean | EventListenerOptions | undefined): void
}

export class EventHelper<T extends EmptyEventHandlerMap> {
    private listeners: { type: keyof T; listener: (e: any) => void }[] = []

    constructor(private element: EventEmitter<T>) {}

    public registerListener<E extends keyof T>(
        type: E,
        listener: (e: T[E]) => void
    ): void {
        this.element.addEventListener(type, listener)
        this.listeners.push({ type, listener })
    }

    public destroy(): void {
        this.listeners.forEach(({ type, listener }) => {
            this.element.removeEventListener(type, listener)
        })
    }
}

export class CustomEventDispatcher<T extends EmptyEventHandlerMap> {
    #eventTarget = new EventTarget()

    dispatchEvent(event: Event): boolean {
        return this.#eventTarget.dispatchEvent(event)
    }

    dispatch<E extends keyof T>(type: E, data? : T[E]) {
        this.dispatchEvent(new CustomEvent(type as any, {detail: data}))
    }

    addEventListener<E extends keyof T>(type : E, listener: ((this: any, ev: CustomEvent<T[E]>) => any) | null, options?: boolean | AddEventListenerOptions | undefined) {
        return this.#eventTarget.addEventListener(type as string, listener as any, options)
    }
    removeEventListener<E extends keyof T>(type: E, listener: (this: any, ev: CustomEvent<T[E]>) => any) {
        return this.#eventTarget.removeEventListener(type as string, listener as any)
    }
}